(function () {
  if (window.__themeUpcartHideDiscountInitialized) {
    return;
  }
  window.__themeUpcartHideDiscountInitialized = true;

  var quantitySelector =
    '.upcart-internal-component-product-tile__quantity-selector input[aria-label="Product quantity"], ' +
    '.upcart-public-component-product-tile__quantity-selector input[aria-label="Product quantity"]';

  var discountWrapperSelector =
    '.upcart-internal-component-product-tile__discount-codes, ' +
    '.upcart-public-component-product-tile__discount-codes';

  function getUpcartRoot() {
    if (typeof window.upcartDocumentOfShadowRoot !== 'undefined' && window.upcartDocumentOfShadowRoot) {
      return window.upcartDocumentOfShadowRoot;
    }

    var upcartHostElement = document.getElementById('upCart');
    if (upcartHostElement && upcartHostElement.shadowRoot) {
      return upcartHostElement.shadowRoot;
    }

    return null;
  }

  function findLineItemContainer(discountWrapper, root) {
    var currentElement = discountWrapper;

    while (currentElement && currentElement !== document.body) {
      if (
        currentElement.querySelector &&
        currentElement.querySelector(quantitySelector) &&
        currentElement.querySelector(discountWrapperSelector)
      ) {
        return currentElement;
      }

      if (root.host && currentElement === root.host) {
        break;
      }

      currentElement = currentElement.parentElement;
    }

    return null;
  }

  function updateDiscountVisibility() {
    var upcartRoot = getUpcartRoot();
    if (!upcartRoot || !upcartRoot.querySelectorAll) {
      return;
    }

    var discountWrappers = upcartRoot.querySelectorAll(discountWrapperSelector);

    discountWrappers.forEach(function (discountWrapper) {
      var lineItemContainer = findLineItemContainer(discountWrapper, upcartRoot);
      if (!lineItemContainer) {
        discountWrapper.style.display = '';
        return;
      }

      var quantityInput = lineItemContainer.querySelector(quantitySelector);
      if (!quantityInput) {
        discountWrapper.style.display = '';
        return;
      }

      var quantity = parseInt(quantityInput.value, 10);

      if (!isNaN(quantity) && quantity > 3) {
        discountWrapper.style.display = 'none';
      } else {
        discountWrapper.style.display = '';
      }
    });
  }

  function scheduleUpdate() {
    setTimeout(updateDiscountVisibility, 50);
    setTimeout(updateDiscountVisibility, 150);
    setTimeout(updateDiscountVisibility, 400);
    setTimeout(updateDiscountVisibility, 800);
  }

  function initWhenUpcartReady() {
    var upcartRoot = getUpcartRoot();

    if (!upcartRoot) {
      setTimeout(initWhenUpcartReady, 300);
      return;
    }

    scheduleUpdate();

    upcartRoot.addEventListener(
      'click',
      function () {
        scheduleUpdate();
      },
      true
    );

    upcartRoot.addEventListener(
      'input',
      function (event) {
        if (event.target.matches(quantitySelector)) {
          scheduleUpdate();
        }
      },
      true
    );

    upcartRoot.addEventListener(
      'change',
      function (event) {
        if (event.target.matches(quantitySelector)) {
          scheduleUpdate();
        }
      },
      true
    );

    var mutationObserver = new MutationObserver(function () {
      scheduleUpdate();
    });

    mutationObserver.observe(upcartRoot, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenUpcartReady);
  } else {
    initWhenUpcartReady();
  }
})();